import React from 'react'
import LoginContainer from '../components/LoginContainer/LoginContainer'

function Login() {
  return (
    <div>
<LoginContainer/>
    </div>
  )
}

export default Login
